<div class="row g-3 orders-container">
  <div class="orders-header-container">
    <div class="orders-search-container">
      <input class="form-control orders-search-input" type="search" [(ngModel)]="filterText"
             placeholder="Filter by company name, order number, or IMEI.">
      <button class="btn btn-outline-primary" (click)="createOrder()">CREATE</button>
    </div>
    <mat-checkbox [disabled]="isLoadingOrders" (change)="toggleFilter()">Show all orders</mat-checkbox>
  </div>
  @for (orderStatus of ORDER_STATUSES; track orderStatus.status) {
    <div id="{{orderStatus.status}}" class="border-start border-primary-subtle col"
         cdkDropList [cdkDropListData]="orderStatus.ordersList"
         [cdkDropListConnectedTo]="dropListConnectedTo(orderStatus.status)"
         (cdkDropListDropped)="drop($event)">
      <h5 class="order-status-header">{{orderStatus.label}}</h5>
      <section>
        @for (order of filterOrders(orderStatus.ordersList); track order.orderId) {
          <app-order [order]="order" [groupOrders]="getOrdersMethod()"></app-order>
        }
      </section>
    </div>
  }
</div>
